import filestack from 'filestack-js';

export default {
  methods: {
    fileStackInit: async (options = {}) => {
      const fsClient = filestack.init('AQHBRnjjlSmeAoiE5PxHoz');

      const files = await fsClient.pick({
        fromSources: ['local_file_system', 'instagram', 'googledrive', 'dropbox'],
        maxFiles: 10,
        minFiles: 1,
        maxSize: 6 * 1024 * 1024,
        accept: [
          'image/*',
          'video/*',
        ],
        storeTo: { access: 'public' },
        ...options,
      });

      if (!files || !files.filesUploaded || !files.filesUploaded.length) {
        throw 'error uploading';
      }

      return files.filesUploaded;
    },
  },
};
